var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.footerLinks),function(item,index){return _c('li',{key:index,class:{ last: _vm.isLast(index) }},[_c('text-link',{attrs:{"link":item.link}},[_vm._v(_vm._s(item.text))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }